import * as importedSdk from 'sharetribe-flex-sdk';

let exportSdk;

const isServer = () => typeof window === 'undefined';

if (isServer()) {
  // Only resolve at runtime on server; webpackIgnore prevents bundling in client build
  exportSdk = require(/* webpackIgnore: true */ 'sharetribe-flex-sdk');
} else {
  exportSdk = importedSdk;
}

const { createInstance, types, transit, util } = exportSdk;

// create image variant from variant name, desired width and aspectRatio
//
// 🔴 Story 12.15 (AC-2a) — `fit` is now a parameter, DEFAULTING TO `'crop'`.
// Every pre-existing call site passes three arguments and is therefore
// byte-identical in behaviour; `util/sdkLoader.test.js` pins that
// as a table over the real call-site arguments (AC-15(c), mutation 11).
//
// The fourth value cards need is `'scale'`: an ASPECT-PRESERVING bounding-box
// fit (probed live against the Marketplace API — `w:600;h:600;fit:scale` →
// 200 OK, `399x600`, resolving to `fit=clip` on the imgix URL). A card cannot
// honour a seller's focal point against a `fit:'crop'` derivative, because
// those pixels have already been discarded before the browser sees them.
//
// ⚠️ The `> 3072` clamp below is UNTOUCHED, including its pre-existing dead
// `else if` branch (the second test reads `variantHeight` where it was plainly
// meant to read `variantWidth`). Upstream Sharetribe code, unreachable, and
// both `frame-*` sizes are an order of magnitude below the cap. Ledgered, not
// fixed here — "untouched" means untouched.
const createImageVariantConfig = (name, width, aspectRatio, fit = 'crop') => {
  let variantWidth = width;
  let variantHeight = Math.round(aspectRatio * width);

  if (variantWidth > 3072 || variantHeight > 3072) {
    if (!isServer) {
      console.error(`Dimensions of custom image variant (${name}) are too high (w:${variantWidth}, h:${variantHeight}).
      Reduce them to max 3072px. https://www.sharetribe.com/api-reference/marketplace.html#custom-image-variants`);
    }

    if (variantHeight > 3072) {
      variantHeight = 3072;
      variantWidth = Math.round(variantHeight / aspectRatio);
    } else if (variantHeight > 3072) {
      variantWidth = 3072;
      variantHeight = Math.round(aspectRatio * variantWidth);
    }
  }

  return {
    [`imageVariant.${name}`]: util.objectQueryString({
      w: variantWidth,
      h: variantHeight,
      fit,
    }),
  };
};

export { createInstance, types, transit, util, createImageVariantConfig };
